export function initNumberAnimation() {
  const numberElements = document.querySelectorAll(".history__card-number");
  if (numberElements.length) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateNumber(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    numberElements.forEach((el) => {
      observer.observe(el);
    });
  }
}

function animateNumber(numberElement) {
  const reg = /[0-9]+/;
  const content = numberElement.textContent || "0";
  const match = content.match(reg);

  if (!match) return;

  const n = Number(match[0]);
  const parts = content.split(reg);

  if (!n && !isNaN(n)) return;

  let i = 0;
  const increment = n / 200;

  function updateText() {
    if (i <= n) {
      numberElement.textContent =
        parts[0] + formatNumber(Math.ceil(i)) + parts[1];
      i += increment;

      setTimeout(updateText, 4);
    } else {
      numberElement.textContent = parts[0] + formatNumber(n) + parts[1];
    }
  }

  updateText();
}

function formatNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
